import * as i0 from '@angular/core';
import { Pipe, Injectable, Component, Inject, Input, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import * as i1 from '@angular/platform-browser';
import * as i1$1 from 'ngx-shared-services';
import { CookieService } from 'ngx-shared-services';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import * as i1$2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i1$3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
/** @nocollapse */ SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16)); };
/** @nocollapse */ SafePipe.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: i1.DomSanitizer }]; }, null); })();

class GlobalFeedbackService {
    constructor(ngxCookieService) {
        this.ngxCookieService = ngxCookieService;
    }
    getCookie(cookieName) {
        return this.ngxCookieService.getCookie(cookieName);
    }
    setCookie(cookieName, cookieValue) {
        const ms = Date.now() + 90 * 86400000;
        const exp = new Date(ms).toDateString();
        const host = document.location.hostname;
        const regex = /.enelx.*/;
        const domain = host.match(regex);
        this.ngxCookieService.setCookie(cookieName, cookieValue, {
            'expires': exp,
            'path': '/',
            'max-age': 7200,
            'domain': domain ? domain[0] : 'localhost',
        });
    }
}
/** @nocollapse */ GlobalFeedbackService.ɵfac = function GlobalFeedbackService_Factory(t) { return new (t || GlobalFeedbackService)(i0.ɵɵinject(i1$1.CookieService)); };
/** @nocollapse */ GlobalFeedbackService.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: GlobalFeedbackService, factory: GlobalFeedbackService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalFeedbackService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1$1.CookieService }]; }, null); })();

class SurveyComponent {
    constructor(dialogRef, data, dialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.url = '';
    }
    openSurvey() {
        this.dialog.open(SurveyComponent, {
            disableClose: true,
            data: this.data,
        });
    }
    ngOnInit() {
        const { Survey_Response_Flex_User_Email, Survey_Response_Flex_User_Username, Survey_Response_Community_User_ID, gf_unique, } = this.data.urlParams;
        const url = new URL(this.data.iFrameUrl);
        url.searchParams.append('Survey_Response_Flex_User_Email', Survey_Response_Flex_User_Email);
        url.searchParams.append('Survey_Response_Flex_User_Username', Survey_Response_Flex_User_Username);
        url.searchParams.append('Survey_Response_Community_User_ID', Survey_Response_Community_User_ID);
        url.searchParams.append('gf_unique', gf_unique);
        this.url = url.href;
    }
    closeSurvey() {
        this.dialog.closeAll();
    }
}
/** @nocollapse */ SurveyComponent.ɵfac = function SurveyComponent_Factory(t) { return new (t || SurveyComponent)(i0.ɵɵdirectiveInject(i1$2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$2.MatDialog)); };
/** @nocollapse */ SurveyComponent.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SurveyComponent, selectors: [["survey"]], decls: 6, vars: 3, consts: [[1, "survey-body"], ["mat-icon-button", "", 1, "close", 3, "click"], ["title", "Feedback Survey", 3, "src"]], template: function SurveyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function SurveyComponent_Template_button_click_1_listener() { return ctx.closeSurvey(); });
        i0.ɵɵelementStart(2, "mat-icon");
        i0.ɵɵtext(3, "close");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(4, "iframe", 2);
        i0.ɵɵpipe(5, "safe");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", i0.ɵɵpipeBind1(5, 1, ctx.url), i0.ɵɵsanitizeResourceUrl);
    } }, dependencies: [i2.MatButton, i1$3.MatIcon, SafePipe], styles: [".close.mat-icon-button[_ngcontent-%COMP%]{float:right;top:5px;right:0;margin-right:5px;margin-top:5px;color:#fff;position:absolute;background-color:#bdbdbd!important}.survey-body[_ngcontent-%COMP%]{width:100%;height:100%;overflow:hidden;position:relative}.survey-body[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{width:100%;height:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SurveyComponent, [{
        type: Component,
        args: [{ selector: 'survey', template: "<div class=\"survey-body\">\r\n    <button (click)=\"closeSurvey()\" class=\"close\" mat-icon-button>\r\n        <mat-icon>close</mat-icon>\r\n    </button>\r\n    <iframe\r\n        title=\"Feedback Survey\"\r\n        [src]=\"url | safe\"\r\n    >\r\n    </iframe>\r\n</div>\r\n", styles: [".close.mat-icon-button{float:right;top:5px;right:0;margin-right:5px;margin-top:5px;color:#fff;position:absolute;background-color:#bdbdbd!important}.survey-body{width:100%;height:100%;overflow:hidden;position:relative}.survey-body iframe{width:100%;height:100%}\n"] }]
    }], function () { return [{ type: i1$2.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$2.MatDialog }]; }, null); })();

const INFO_ICON_PURPLE = `
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 7H13.5V9H11.5V7ZM11.5 11H13.5V17H11.5V11ZM12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20Z" fill="#461E7D"/>
  </svg>
  `;
const INFO_ICON_YELLOW = `
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 7H13.5V9H11.5V7ZM11.5 11H13.5V17H11.5V11ZM12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20Z" fill="#EECC16"/>
  </svg>
  `;
const HIGHLIGHT_OFF_ICON_PURPLE = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#461E7D"/>
  </svg>
  `;
const HIGHLIGHT_OFF_ICON_YELLOW = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#EECC16"/>
  </svg>
  `;
const CHECK_CIRCLE_OUTLINE_ICON_PURPLE = `
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM17.09 7.58L10.5 14.17L7.91 11.59L6.5 13L10.5 17L18.5 9L17.09 7.58Z" fill="#461E7D"/>
  </svg>
  `;
const CHECK_CIRCLE_OUTLINE_ICON_YELLOW = `
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM17.09 7.58L10.5 14.17L7.91 11.59L6.5 13L10.5 17L18.5 9L17.09 7.58Z" fill="#EECC16"/>
  </svg>
  `;
class SnackBarComponent {
    constructor(matIconRegistry, domSanitizer, dialog, globalFeedbackService, snackBarRef) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.dialog = dialog;
        this.globalFeedbackService = globalFeedbackService;
        this.snackBarRef = snackBarRef;
        this.infoIcon = '';
        this.cancelIcon = '';
        this.checkIcon = '';
        this.snackBarTheme = '';
        this.matIconRegistry.addSvgIconLiteral('info-purple', this.domSanitizer.bypassSecurityTrustHtml(INFO_ICON_PURPLE));
        this.matIconRegistry.addSvgIconLiteral('info-yellow', this.domSanitizer.bypassSecurityTrustHtml(INFO_ICON_YELLOW));
        this.matIconRegistry.addSvgIconLiteral('highlight-off-purple', this.domSanitizer.bypassSecurityTrustHtml(HIGHLIGHT_OFF_ICON_PURPLE));
        this.matIconRegistry.addSvgIconLiteral('highlight-off-yellow', this.domSanitizer.bypassSecurityTrustHtml(HIGHLIGHT_OFF_ICON_YELLOW));
        this.matIconRegistry.addSvgIconLiteral('check-circle-outline-purple', this.domSanitizer.bypassSecurityTrustHtml(CHECK_CIRCLE_OUTLINE_ICON_PURPLE));
        this.matIconRegistry.addSvgIconLiteral('check-circle-outline-yellow', this.domSanitizer.bypassSecurityTrustHtml(CHECK_CIRCLE_OUTLINE_ICON_YELLOW));
    }
    ngOnInit() {
        this.globalFeedbackData = this.snackBarRef.containerInstance.snackBarConfig.data;
        this.snackBarTheme = this.globalFeedbackData.snackBarTheme;
        switch (this.snackBarTheme) {
            case 'snack-style-purple':
                this.infoIcon = 'info-purple';
                this.cancelIcon = 'highlight-off-purple';
                this.checkIcon = 'check-circle-outline-purple';
                break;
            case 'snack-style-yellow':
                this.infoIcon = 'info-yellow';
                this.cancelIcon = 'highlight-off-yellow';
                this.checkIcon = 'check-circle-outline-yellow';
                break;
        }
    }
    openSurvey() {
        this.closeSnackBar();
        this.globalFeedbackService.setCookie('get_feedback', 'filled');
        this.dialog.open(SurveyComponent, {
            disableClose: true,
            width: this.globalFeedbackData.widthSurveyBox,
            height: this.globalFeedbackData.heightSurveyBox,
            data: {
                iFrameUrl: this.globalFeedbackData.iFrameUrl,
                urlParams: {
                    Survey_Response_Flex_User_Email: this.globalFeedbackData.urlParams.Survey_Response_Flex_User_Email,
                    Survey_Response_Flex_User_Username: this.globalFeedbackData.urlParams.Survey_Response_Flex_User_Username,
                    Survey_Response_Community_User_ID: this.globalFeedbackData.urlParams.Survey_Response_Community_User_ID,
                    gf_unique: this.globalFeedbackData.urlParams.gf_unique,
                },
            },
        });
    }
    closeSnackBar() {
        this.snackBarRef.dismiss();
    }
}
/** @nocollapse */ SnackBarComponent.ɵfac = function SnackBarComponent_Factory(t) { return new (t || SnackBarComponent)(i0.ɵɵdirectiveInject(i1$3.MatIconRegistry), i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i1$2.MatDialog), i0.ɵɵdirectiveInject(GlobalFeedbackService), i0.ɵɵdirectiveInject(i5.MatSnackBarRef)); };
/** @nocollapse */ SnackBarComponent.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SnackBarComponent, selectors: [["snack-bar"]], decls: 12, vars: 4, consts: [[1, "container"], [1, "row"], ["mat-raised-button", "", 1, "info-button", 3, "disabled"], ["aria-hidden", "false", 3, "svgIcon"], [1, "message"], ["mat-icon-button", "", "aria-label", "No", 3, "click"], ["mat-icon-button", "", "aria-label", "Yes", 3, "click"]], template: function SnackBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div")(3, "button", 2);
        i0.ɵɵelement(4, "mat-icon", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6, "Would you like to provide feedback?");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "div")(8, "button", 5);
        i0.ɵɵlistener("click", function SnackBarComponent_Template_button_click_8_listener() { return ctx.closeSnackBar(); });
        i0.ɵɵelement(9, "mat-icon", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "button", 6);
        i0.ɵɵlistener("click", function SnackBarComponent_Template_button_click_10_listener() { return ctx.openSurvey(); });
        i0.ɵɵelement(11, "mat-icon", 3);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("svgIcon", ctx.infoIcon);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("svgIcon", ctx.cancelIcon);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("svgIcon", ctx.checkIcon);
    } }, dependencies: [i2.MatButton, i1$3.MatIcon], styles: [".message[_ngcontent-%COMP%]{clear:both;display:inline-block;overflow:hidden;white-space:nowrap;font-family:var(--font);font-style:normal;font-weight:300;font-size:14px;line-height:17px;color:#333!important;margin-left:11.58px}  .snack-style-purple{display:block;background-color:#f2f0f9;width:100%;max-width:100vw;border-radius:4px;box-sizing:border-box}  .snack-style-yellow{display:block;background-color:#fff8e0;width:100%;max-width:100vw;border-radius:4px;box-sizing:border-box}.container[_ngcontent-%COMP%]{display:flex-inline}.row[_ngcontent-%COMP%]{display:flex;justify-content:space-between}mat-icon[_ngcontent-%COMP%]{color:#461e7d}@media screen and (max-width: 599px){  .mat-snack-bar-handset .mat-snack-bar-container{margin:0}}@media screen and (max-width: 397px){  snack-bar div.container div.row{display:flex;flex-direction:column;align-items:center}  snack-bar div.container div.row div:nth-child(1) button span.mat-button-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:center;width:100%}  snack-bar div.container div.row div:nth-child(2){display:flex;justify-content:center;flex-direction:row;width:100%}  snack-bar div.container div.row div:nth-child(2) button:nth-child(1),   snack-bar div.container div.row div:nth-child(2) button:nth-child(2){margin:0 10px}}@media screen and (max-width: 397px) and (max-width: 397px){  snack-bar div.container div.row div:nth-child(2) button:nth-child(1) span.mat-button-wrapper mat-icon,   snack-bar div.container div.row div:nth-child(2) button:nth-child(2) span.mat-button-wrapper mat-icon{width:35px;height:35px}}.info-button[_ngcontent-%COMP%]{background:transparent!important;box-shadow:none!important;opacity:unset!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SnackBarComponent, [{
        type: Component,
        args: [{ selector: 'snack-bar', template: "\r\n<div class=\"container\">\r\n  <div class=\"row\">\r\n      <div>\r\n          <button [disabled]=\"true\" class=\"info-button\" mat-raised-button>\r\n              <mat-icon aria-hidden=\"false\" [svgIcon]=\"infoIcon\"></mat-icon>\r\n              <div class=\"message\">Would you like to provide feedback?</div>\r\n          </button>\r\n      </div>\r\n      <div>\r\n          <button (click)=\"closeSnackBar()\" mat-icon-button aria-label=\"No\">\r\n              <mat-icon aria-hidden=\"false\" [svgIcon]=\"cancelIcon\"></mat-icon>\r\n          </button>\r\n\r\n          <button (click)=\"openSurvey()\" mat-icon-button aria-label=\"Yes\">\r\n              <mat-icon aria-hidden=\"false\" [svgIcon]=\"checkIcon\"></mat-icon>\r\n          </button>\r\n      </div>\r\n  </div>\r\n</div>\r\n", styles: [".message{clear:both;display:inline-block;overflow:hidden;white-space:nowrap;font-family:var(--font);font-style:normal;font-weight:300;font-size:14px;line-height:17px;color:#333!important;margin-left:11.58px}::ng-deep .snack-style-purple{display:block;background-color:#f2f0f9;width:100%;max-width:100vw;border-radius:4px;box-sizing:border-box}::ng-deep .snack-style-yellow{display:block;background-color:#fff8e0;width:100%;max-width:100vw;border-radius:4px;box-sizing:border-box}.container{display:flex-inline}.row{display:flex;justify-content:space-between}mat-icon{color:#461e7d}@media screen and (max-width: 599px){::ng-deep .mat-snack-bar-handset .mat-snack-bar-container{margin:0}}@media screen and (max-width: 397px){::ng-deep snack-bar div.container div.row{display:flex;flex-direction:column;align-items:center}::ng-deep snack-bar div.container div.row div:nth-child(1) button span.mat-button-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:center;width:100%}::ng-deep snack-bar div.container div.row div:nth-child(2){display:flex;justify-content:center;flex-direction:row;width:100%}::ng-deep snack-bar div.container div.row div:nth-child(2) button:nth-child(1),::ng-deep snack-bar div.container div.row div:nth-child(2) button:nth-child(2){margin:0 10px}}@media screen and (max-width: 397px) and (max-width: 397px){::ng-deep snack-bar div.container div.row div:nth-child(2) button:nth-child(1) span.mat-button-wrapper mat-icon,::ng-deep snack-bar div.container div.row div:nth-child(2) button:nth-child(2) span.mat-button-wrapper mat-icon{width:35px;height:35px}}.info-button{background:transparent!important;box-shadow:none!important;opacity:unset!important}\n"] }]
    }], function () { return [{ type: i1$3.MatIconRegistry }, { type: i1.DomSanitizer }, { type: i1$2.MatDialog }, { type: GlobalFeedbackService }, { type: i5.MatSnackBarRef }]; }, null); })();

class GlobalFeedbackComponent {
    constructor(dialog, _snackBar, globalFeedbackService) {
        this.dialog = dialog;
        this._snackBar = _snackBar;
        this.globalFeedbackService = globalFeedbackService;
        this.iFrameUrl = '';
        this.snackBarTheme = '';
        this.urlParams = {
            Survey_Response_Flex_User_Email: '',
            Survey_Response_Flex_User_Username: '',
            Survey_Response_Community_User_ID: '',
            gf_unique: '',
        };
        this.labelYesButton = '';
        this.labelNoButton = '';
        this.message = '';
        this.widthSurveyBox = '';
        this.heightSurveyBox = '';
        this.disableClose = false;
        this._iFrameUrl = '';
        this._snackBarTheme = '';
        this._urlParams = {
            Survey_Response_Flex_User_Email: '',
            Survey_Response_Flex_User_Username: '',
            Survey_Response_Community_User_ID: '',
            gf_unique: '',
        };
        this._message = '';
        this._labelYesButton = '';
        this._labelNoButton = '';
        this._widthSurveyBox = '';
        this._heightSurveyBox = '';
        this._disableClose = false;
    }
    ngOnInit() {
        this._iFrameUrl = this.iFrameUrl;
        this._snackBarTheme = this.snackBarTheme,
            this._urlParams = this.urlParams;
        this._message = this.message;
        this._labelYesButton = this.labelYesButton;
        this._labelNoButton = this.labelNoButton;
        this._widthSurveyBox = this.widthSurveyBox;
        this._heightSurveyBox = this.heightSurveyBox;
        this._disableClose = this.disableClose;
        this.cookieValue = this.globalFeedbackService.getCookie('get_feedback');
        if (this.cookieValue !== 'filled') {
            this.openSnackBar();
        }
    }
    openSnackBar() {
        this._snackBar.openFromComponent(SnackBarComponent, {
            panelClass: [this._snackBarTheme],
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            data: {
                iFrameUrl: this._iFrameUrl,
                urlParams: this._urlParams,
                message: this._message,
                labelYesButton: this._labelYesButton,
                labelNoButton: this.labelNoButton,
                widthSurveyBox: this._widthSurveyBox,
                heightSurveyBox: this._heightSurveyBox,
                disableClose: this._disableClose,
                snackBarTheme: this._snackBarTheme,
            },
        });
    }
}
/** @nocollapse */ GlobalFeedbackComponent.ɵfac = function GlobalFeedbackComponent_Factory(t) { return new (t || GlobalFeedbackComponent)(i0.ɵɵdirectiveInject(i1$2.MatDialog), i0.ɵɵdirectiveInject(i5.MatSnackBar), i0.ɵɵdirectiveInject(GlobalFeedbackService)); };
/** @nocollapse */ GlobalFeedbackComponent.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: GlobalFeedbackComponent, selectors: [["ngx-global-feedback"]], inputs: { iFrameUrl: "iFrameUrl", snackBarTheme: "snackBarTheme", urlParams: "urlParams", labelYesButton: "labelYesButton", labelNoButton: "labelNoButton", message: "message", widthSurveyBox: "widthSurveyBox", heightSurveyBox: "heightSurveyBox", disableClose: "disableClose" }, decls: 0, vars: 0, template: function GlobalFeedbackComponent_Template(rf, ctx) { } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalFeedbackComponent, [{
        type: Component,
        args: [{ selector: 'ngx-global-feedback', template: "" }]
    }], function () { return [{ type: i1$2.MatDialog }, { type: i5.MatSnackBar }, { type: GlobalFeedbackService }]; }, { iFrameUrl: [{
            type: Input
        }], snackBarTheme: [{
            type: Input
        }], urlParams: [{
            type: Input
        }], labelYesButton: [{
            type: Input
        }], labelNoButton: [{
            type: Input
        }], message: [{
            type: Input
        }], widthSurveyBox: [{
            type: Input
        }], heightSurveyBox: [{
            type: Input
        }], disableClose: [{
            type: Input
        }] }); })();

class GlobalFeedbackModule {
}
/** @nocollapse */ GlobalFeedbackModule.ɵfac = function GlobalFeedbackModule_Factory(t) { return new (t || GlobalFeedbackModule)(); };
/** @nocollapse */ GlobalFeedbackModule.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: GlobalFeedbackModule });
/** @nocollapse */ GlobalFeedbackModule.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [CookieService, GlobalFeedbackService], imports: [MatButtonModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatCardModule,
        HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalFeedbackModule, [{
        type: NgModule,
        args: [{
                declarations: [GlobalFeedbackComponent, SurveyComponent, SafePipe, SnackBarComponent],
                imports: [
                    MatButtonModule,
                    MatDialogModule,
                    MatDividerModule,
                    MatIconModule,
                    MatFormFieldModule,
                    MatSnackBarModule,
                    MatCardModule,
                    HttpClientModule,
                ],
                exports: [GlobalFeedbackComponent],
                providers: [CookieService, GlobalFeedbackService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GlobalFeedbackModule, { declarations: [GlobalFeedbackComponent, SurveyComponent, SafePipe, SnackBarComponent], imports: [MatButtonModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatCardModule,
        HttpClientModule], exports: [GlobalFeedbackComponent] }); })();

/*
 * Public API Surface of ngx-global-feedback
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GlobalFeedbackComponent, GlobalFeedbackModule };
